const formatUTCDate = (value) => {
  const fechaUTC = new Date(value);

  if (Number.isNaN(fechaUTC.getTime())) return "";

  return `${fechaUTC.getUTCFullYear()}-${String(
    fechaUTC.getUTCMonth() + 1
  ).padStart(2, "0")}-${String(fechaUTC.getUTCDate()).padStart(2, "0")} ${String(
    fechaUTC.getUTCHours()
  ).padStart(2, "0")}:${String(fechaUTC.getUTCMinutes()).padStart(
    2,
    "0"
  )}:${String(fechaUTC.getUTCSeconds()).padStart(2, "0")}`;
};

const formatFaultDate = (value) => {
  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

const columns = [
  { field: "id", headerName: "ID", width: 90 },
  { field: "tipoMaquinaControl", headerName: "Tipo de Máquina y Control", minWidth: 200, flex: 1 },
  { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 150, flex: 1 },
  { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },
  { field: "tempSuccionComp1", headerName: "Temp. Succión Comp. 1", minWidth: 200, flex: 1 },
  { field: "tempProcesoEntrada", headerName: "Temp. Proceso Entrada", minWidth: 200, flex: 1 },
  { field: "tempProcesoSalida", headerName: "Temp. Proceso Salida", minWidth: 200, flex: 1 },
  { field: "tempTorreEntrada", headerName: "Temp. Torre Entrada", minWidth: 200, flex: 1 },
  { field: "tempTorreSalida", headerName: "Temp. Torre Salida", minWidth: 200, flex: 1 },
  { field: "tempDescargaComp1", headerName: "Temp. Descarga Compresor 1", minWidth: 200, flex: 1 },
  { field: "tempCoThermEntrada", headerName: "Temp. CoTherm Entrada", minWidth: 200, flex: 1 },
  { field: "tempRefrPrecalSalidaC1", headerName: "Temp. Refr Precal Salida Circuito 1", minWidth: 250, flex: 1 },
  { field: "tempCoThermSalida", headerName: "Temp. CoTherm Salida", minWidth: 200, flex: 1 },
  { field: "presionSuccionComp1", headerName: "Presión Succión Comp. 1", minWidth: 200, flex: 1 },
  { field: "presionDescargaComp1", headerName: "Presión Descarga Comp. 1", minWidth: 200, flex: 1 },
  { field: "voltajeCmp1", headerName: "Voltaje Comp. 1", minWidth: 200, flex: 1 },
  { field: "amperajeCmp1", headerName: "Amperaje Comp. 1", minWidth: 200, flex: 1 },
  { field: "sobrecalentamientoCmp1", headerName: "Sobrecalentamiento Comp. 1", minWidth: 200, flex: 1 },
  { field: "condicionActualComp1", headerName: "Condición Actual Comp. 1", minWidth: 200, flex: 1 },
  { field: "porcentajeCargaComp1", headerName: "Porcentaje Carga Comp. 1", minWidth: 200, flex: 1 },
  { field: "leaderSecondaryComp1", headerName: "Leader / Secondary Comp. 1", minWidth: 200, flex: 1 },
  { field: "controlCarga", headerName: "Control de Carga", minWidth: 200, flex: 1 },
  { field: "ramploading", headerName: "Ramploading", minWidth: 200, flex: 1 },
  { field: "switchFlujoAguaCondensacion", headerName: "Switch Flujo Agua Condensación", minWidth: 200, flex: 1 },
  { field: "switchFlujoAguaHelada", headerName: "Switch Flujo Agua Helada", minWidth: 200, flex: 1 },
  { field: "bajoNivelAceiteComp1", headerName: "Bajo Nivel Aceite Comp. 1", minWidth: 200, flex: 1 },
  { field: "statusTempMotorComp1", headerName: "Status Temp Motor Comp. 1", minWidth: 200, flex: 1 },
  { field: "interlockComp1", headerName: "Interlock Comp. 1", minWidth: 200, flex: 1 },
  { field: "statusMotorProtect1", headerName: "Status MotorProtect 1", minWidth: 200, flex: 1 },
  { field: "arranqueRemoto", headerName: "Arranque Remoto", minWidth: 200, flex: 1 },
  { field: "paroEmergencia", headerName: "Paro de Emergencia", minWidth: 200, flex: 1 },
  { field: "encendidoComp1", headerName: "Encendido Compresor 1", minWidth: 200, flex: 1 },
  { field: "loadUnloadValvula1Comp1", headerName: "Load/Unload Válvula 1 Comp. 1", minWidth: 200, flex: 1 },
  { field: "loadUnloadValvula2Comp1", headerName: "Load/Unload Válvula 2 Comp. 1", minWidth: 200, flex: 1 },
  { field: "loadUnloadValvula3Comp1", headerName: "Load/Unload Válvula 3 Comp. 1", minWidth: 200, flex: 1 },
  { field: "output04", headerName: "Output 04", minWidth: 200, flex: 1 },
  { field: "output05", headerName: "Output 05", minWidth: 200, flex: 1 },
  { field: "output06", headerName: "Output 06", minWidth: 200, flex: 1 },
  { field: "output07", headerName: "Output 07", minWidth: 200, flex: 1 },
  { field: "output08", headerName: "Output 08", minWidth: 200, flex: 1 },
  { field: "output09", headerName: "Output 09", minWidth: 200, flex: 1 },
  { field: "output10", headerName: "Output 10", minWidth: 200, flex: 1 },
  { field: "encendidoCoThermC1", headerName: "Encendido Co-Therm C1", minWidth: 200, flex: 1 },
  { field: "output12", headerName: "Output 12", minWidth: 200, flex: 1 },
  { field: "output13", headerName: "Output 13", minWidth: 200, flex: 1 },
  { field: "fechaFalla1", headerName: "Fecha de Falla 1", minWidth: 200, flex: 1 },
  { field: "numeroFalla1", headerName: "Número de Falla 1", minWidth: 300, flex: 1 },
  { field: "fechaFalla2", headerName: "Fecha de Falla 2", minWidth: 200, flex: 1 },
  { field: "numeroFalla2", headerName: "Número de Falla 2", minWidth: 300, flex: 1 },
  { field: "fechaFalla3", headerName: "Fecha de Falla 3", minWidth: 200, flex: 1 },
  { field: "numeroFalla3", headerName: "Número de Falla 3", minWidth: 300, flex: 1 },
  { field: "fechaFalla4", headerName: "Fecha de Falla 4", minWidth: 200, flex: 1 },
  { field: "numeroFalla4", headerName: "Número de Falla 4", minWidth: 300, flex: 1 },
  { field: "fechaFalla5", headerName: "Fecha de Falla 5", minWidth: 200, flex: 1 },
  { field: "numeroFalla5", headerName: "Número de Falla 5", minWidth: 300, flex: 1 },
  { field: "tiempoServicioHoras", headerName: "Tiempo de Servicio en Horas", minWidth: 200, flex: 1 },
  { field: "horasTotalesOperacion", headerName: "Horas Totales de Operación", minWidth: 200, flex: 1 },
];

const mapRow = (row, index) => ({
  id: index + 1,
  tipoMaquinaControl: row["Tipo de Máquina y Control"],
  numeroEquipo: row["Número de Equipo"],
  fecha: formatUTCDate(row["Fecha"]),
  tempSuccionComp1: row["Temp. Succion Comp 1"],
  tempProcesoEntrada: row["Temp. Proceso Entrada"],
  tempProcesoSalida: row["Temp. Proceso Salida"],
  tempTorreEntrada: row["Temp. Torre Entrada"],
  tempTorreSalida: row["Temp. Torre Salida"],
  tempDescargaComp1: row["Temp. Descarga Compresor 1"],
  tempCoThermEntrada: row["Temp. CoTherm Entrada"],
  tempRefrPrecalSalidaC1: row["Temp. Refr Precal Salida Circuito 1"],
  tempCoThermSalida: row["Temp. CoTherm Salida"],
  presionSuccionComp1: row["Presion Succion Comp 1"],
  presionDescargaComp1: row["Presion Descarga Comp 1"],
  voltajeCmp1: row["Voltaje Cmp 1"],
  amperajeCmp1: row["Amperaje Cmp 1"],
  sobrecalentamientoCmp1: row["Sobrecalentamiento Cmp 1"],
  condicionActualComp1: row["Condicion Actual Comp 1"],
  porcentajeCargaComp1: row["Porcentaje Carga Comp 1"],
  leaderSecondaryComp1: row["Leader / Secondary Comp 1"],
  controlCarga: row["Control de Carga"],
  ramploading: row["Ramploading"],
  switchFlujoAguaCondensacion: row["Switch Flujo Agua Condensacion"],
  switchFlujoAguaHelada: row["Switch Flujo Agual Helada"],
  bajoNivelAceiteComp1: row["Bajo Nivel Aceite Comp. 1"],
  statusTempMotorComp1: row["Status Temp Motor Comp. 1"],
  interlockComp1: row["Interlock Comp. 1"],
  statusMotorProtect1: row["Status MotorProtect 1"],
  arranqueRemoto: row["Arranque Remoto"],
  paroEmergencia: row["Paro de Emergencia"],
  encendidoComp1: row["Encendido Compresor 1"],
  loadUnloadValvula1Comp1: row["Load/Unload Valvula 1 Comp. 1"],
  loadUnloadValvula2Comp1: row["Load/Unload Valvula 2 Comp. 1"],
  loadUnloadValvula3Comp1: row["Load/Unload Valvula 3 Comp. 1"],
  output04: row["Output_04"],
  output05: row["Output_05"],
  output06: row["Output_06"],
  output07: row["Output_07"],
  output08: row["Output_08"],
  output09: row["Output_09"],
  output10: row["Output_10"],
  encendidoCoThermC1: row["Encendido Co-Therm C1"],
  output12: row["Output_12"],
  output13: row["Output_13"],
  tiempoServicioHoras: row["Tiempo de Servicio en Horas"],
  horasTotalesOperacion: row["Horas Totales de Operación"],
  fechaFalla1: formatFaultDate(row["Fecha de Falla 1"]),
  numeroFalla1: row["Numero de Falla 1"],
  fechaFalla2: formatFaultDate(row["Fecha de Falla 2"]),
  numeroFalla2: row["Numero de Falla 2"],
  fechaFalla3: formatFaultDate(row["Fecha de Falla 3"]),
  numeroFalla3: row["Numero de Falla 3"],
  fechaFalla4: formatFaultDate(row["Fecha de Falla 4"]),
  numeroFalla4: row["Numero de Falla 4"],
  fechaFalla5: formatFaultDate(row["Fecha de Falla 5"]),
  numeroFalla5: row["Numero de Falla 5"],
});

export const optichiller1CompConsultaConfig = {
  title: "Optichiller 1 Comp",
  endpoint:
    "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/optichiller1comp/datos",
  buildRequestBody: ({ idEquipo, fechaInicio, fechaFinal }) => ({
    idEquipo,
    fechaInicio,
    fechaFinal,
    tipoMaquina: "Optichiller 1Comp",
    tipoConsulta: "Datos",
  }),
  columns,
  mapRow,
};